import { Box, Typography } from "@mui/material";
import { Colors } from "Components/Layout/Themes/Colors";
import { BlDivider } from "Components/Shared/BlDivider";
import { PrimaryButton } from "Components/Shared/Buttons/PrimaryButton";
import { GmailLogoIcon } from "Components/Shared/Icons";
import { useNavigate } from "Navigation/useNavigate";
import { resetUser } from "State/Auth/AuthReducer";
import { appUrl } from "Utils/UrlUtils";
import { useDispatch } from "react-redux";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES =
  Resources.Pages.Content.CustomerAnonymousPaymentPay.ConfirmBox;

const onClose = () => {
  // TODO: env file
  window.location.href = "https://mo.one";
};

export const ConfirmBox = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useResource();

  const onCreateAccount = () => {
    // TODO: redirect to onboarding after merged
    dispatch(resetUser({ onAfterReset: () => navigate(appUrl("sign-up")) }));
  };

  return (
    <Box display="grid" gap={3}>
      <Box display="flex" flexDirection="column" alignItems="center">
        <GmailLogoIcon width="50" height="50" color={Colors.PrimaryMain} />
        <Typography variant="h5" marginY={1}>
          {t(COMPONENT_RESOURCES.Title)}
        </Typography>
      </Box>
      <BlDivider marginY={0} />
      <Typography lineHeight="28px" textAlign="center">
        {t(COMPONENT_RESOURCES.Description)}
      </Typography>
      <PrimaryButton color="primary" onClick={onCreateAccount} fullWidth>
        {t(COMPONENT_RESOURCES.CreateAccountButton)}
      </PrimaryButton>
      <PrimaryButton onClick={onClose} fullWidth>
        {t(COMPONENT_RESOURCES.CloseButton)}
      </PrimaryButton>
    </Box>
  );
};
